import React from 'react';
import { connect } from 'react-redux';
import Counter from '../../../shared/components/Counter';

class TimingSectionCounter extends React.Component {
  render() {
    let value =
      (this.props.durationType && this.props.duration) || this.props.typeOfPain;
    return <Counter value={!!value} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    typeOfPain:
      state.records.current.record &&
      state.records.current.record.lengthOfPainType
        ? state.records.current.record.lengthOfPainType
        : null,
    duration:
      state.records.current.record &&
      state.records.current.record.lengthOfPainValue
        ? state.records.current.record.lengthOfPainValue
        : 0,
    durationType:
      state.records.current.record && state.records.current.record.durationType,
  };
};

export default connect(mapStateToProps)(TimingSectionCounter);
